import React, { Component } from 'react';
import { RECONNECT_EVENT, prepareShopifyReconnect, clearReconnectRequest } from '../helpers/request';

interface ReconnectState { visible: boolean; permissionURL?: string; preparing: boolean; }

export default class ShopifyReconnect extends Component<{}, ReconnectState> {
  state: ReconnectState = { visible: false, preparing: false };
  show = (event: Event) => {
    this.setState({ visible: true, permissionURL: (event as CustomEvent).detail.permissionURL });
  };
  componentDidMount() { window.addEventListener(RECONNECT_EVENT, this.show); }
  componentWillUnmount() { window.removeEventListener(RECONNECT_EVENT, this.show); }
  prepare = async () => {
    clearReconnectRequest();
    this.setState({ preparing: true, permissionURL: undefined });
    try { this.setState({ permissionURL: await prepareShopifyReconnect() }); }
    catch (_) { this.setState({ permissionURL: undefined }); }
    finally { this.setState({ preparing: false }); }
  };
  dismiss = () => {
    clearReconnectRequest();
    this.setState({ visible: false, permissionURL: undefined });
  };
  render() {
    if (!this.state.visible) { return null; }
    return <div role="alert" style={{ background: '#fff4ce', padding: '16px', margin: '16px', borderRadius: '4px' }}>
      <p><strong>Reconnect Shopify</strong></p>
      <p>Authorize ProdVid in a new tab, then return here and retry your action. Your editor stays open.</p>
      {this.state.permissionURL
        ? <a href={this.state.permissionURL} target="_blank" rel="noopener noreferrer">Reconnect Shopify in a new tab</a>
        : <button onClick={this.prepare} disabled={this.state.preparing}>
            {this.state.preparing ? 'Preparing…' : 'Prepare reconnect link'}
          </button>}
      {this.state.permissionURL && <> {' '}<button onClick={this.prepare}>Prepare a new link</button></>}
      {' '}<button onClick={this.dismiss}>I’ve reconnected</button>
    </div>;
  }
}
